import type { AuditStreamConfigurationResource } from "@octopusdeploy/octopus-server-client";
import { AuditStreamConfiguredButton } from "~/areas/configuration/components/AuditLayout/AuditStream/AuditStreamConfiguredButton";
import { AuditStreamNotConfiguredButton } from "~/areas/configuration/components/AuditLayout/AuditStream/AuditStreamNotConfiguredButton";
import { AuditStreamUpsellButton } from "~/areas/configuration/components/AuditLayout/AuditStream/AuditStreamUpsellButton";
interface AuditStreamButtonProps {
    auditStreamConfiguration: AuditStreamConfigurationResource | null;
    onUpdate: (auditStreamConfiguration: AuditStreamConfigurationResource, message: string) => void;
    isTrial: boolean;
}
export function AuditStreamButton({ auditStreamConfiguration, onUpdate, isTrial }: AuditStreamButtonProps) {
    if (!auditStreamConfiguration) {
        return <AuditStreamUpsellButton />;
    }
    if (!auditStreamConfiguration.StreamConfigurationResource) {
        return <AuditStreamNotConfiguredButton auditStreamConfiguration={auditStreamConfiguration} onUpdate={onUpdate} isTrial={isTrial}/>;
    }
    return <AuditStreamConfiguredButton auditStreamConfiguration={auditStreamConfiguration} onUpdate={onUpdate} isTrial={isTrial}/>;
}
